import { TextArea, TextAreaProps } from "@suraasa/placebo-ui"
import { useQueryClient } from "@tanstack/react-query"
import api from "api"
import { APIError } from "api/utils"
import { useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { mapErrors } from "utils/helpers"

type Props = {
  saveKey: string
  value: string | number | null | undefined
  userPrimaryKey: string | number | null | undefined
  disableAutoSave?: boolean
  onUpdate?: (value: any) => void
} & TextAreaProps

const AutoSaveTextArea = (props: Props) => {
  const { userId } = useParams()
  const queryClient = useQueryClient()

  const {
    saveKey,
    value,
    disableAutoSave,
    userPrimaryKey,
    onUpdate,
    ...textAreaProps
  } = props

  const {
    register,
    formState: { errors },
    getValues,
    clearErrors,
    setError,
  } = useForm({
    defaultValues: {
      [saveKey]: value,
    },
  })

  const save = async () => {
    clearErrors()
    const values = getValues()
    const value = values[saveKey]
    if (onUpdate) {
      onUpdate(value)
    }

    if (disableAutoSave) {
      return
    }

    const data = {
      [saveKey]: value,
    }

    try {
      await api.lead.saveData({
        data,
        params: {
          userPrimaryKey,
        },
      })

      // @ts-expect-error this is safe to do
      queryClient.setQueryData<LeadProfile>(["profile", userId], oldData => ({
        ...(oldData ?? {}),
        ...data,
      }))
    } catch (error) {
      if (error instanceof APIError) {
        const err = error.errors

        if (err.message) {
          toast.error(err.message)
          return
        }
        if (err.fieldErrors) {
          mapErrors(setError, err, [[saveKey]])
          return
        }
      }
    }
  }
  return (
    <TextArea
      {...register(saveKey, {
        onBlur: save,
      })}
      errors={errors[saveKey]?.message}
      {...textAreaProps}
    />
  )
}

export default AutoSaveTextArea
